var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00391,
    y: 1.01953,
    width: 21.3974,
    height: 21.3974,
    rx: 3.56624,
    fill: "#243677",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.825594,
    y: 0.841219,
    width: 21.7541,
    height: 21.7541,
    rx: 3.74455,
    stroke: "#243677",
    strokeOpacity: 0.16,
    strokeWidth: 0.356624
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5202_2069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08464 17.0542C7.34105 16.0456 6.16797 14.1605 6.16797 12.0013C6.16797 8.77964 8.77964 6.16797 12.0013 6.16797C15.223 6.16797 17.8346 8.77964 17.8346 12.0013C17.8346 14.1605 16.6616 16.0456 14.918 17.0542M14.3346 12.0013L12.0013 9.66801M12.0013 9.66801L9.66797 12.0013M12.0013 9.66801V17.8347",
    stroke: "#243677",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5202_2069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.8b69e74be6215f0f1c4f5cecf040da81.svg";
export { ForwardRef as ReactComponent };